<template>
  <div class="app flex-row align-items-center" id="form-register">
    <div style="width: 100%;height: 100vh;">
      <CRow class="justify-content-center" style="height: 100%;margin: auto 0!important;">
        <CCol id="content-left" md="8" sm="7"
              style="background:url('../static/img/brand/background.jpg'); background-size: cover; background-repeat: no-repeat">
        </CCol>
        <CCol id="content-right" md="4" sm="5" style="margin:auto;">
          <div class="container">
            <div>
              <!--Logo-->
            </div>
            <CCard no-body style="background: #ffffffba;border: none!important;">
              <CCardBody>
                <!--                <CForm id="form-register">-->
                <h3 style="text-align: center;">Đăng kí tài khoản</h3>
                <!--FullName-->
                <CRow>
                  <CCol sm="12" md="12" xl="12" class="mt-3">
                    <BaseInput :options="fullNameInput.options" :data="fullNameInput.data" class="input-wrapper"/>
                  </CCol>
                  <!--Email-->
                  <CCol sm="12" md="12" xl="12" class="mt-3">
                    <BaseInput :options="emailInput.options" :data="emailInput.data" class="input-wrapper"/>
                  </CCol>
                  <!--UserName-->
                  <CCol sm="12" md="12" xl="12" class="mt-3">
                    <BaseInput :options="userNameInput.options" :data="userNameInput.data" class="input-wrapper"/>
                  </CCol>
                  <!--Password-->
                  <CCol sm="12" md="12" xl="12" class="mt-3">
                    <BaseInput :options="passWordInput.options" :data="passWordInput.data" class="input-wrapper"/>
                  </CCol>
                </CRow>
                <CRow>
                  <CCol cols="12" style="margin-top: 15px!important;">
                    <button type="button" class="px-12 ripple btn-primary" @click="submit"
                            id="register"
                            style="padding: 8px!important; height: 42px!important;border-radius: 2.5rem!important;
                              background: linear-gradient(to right, #6e50ff, #506bff, #0093ff)!important;
                              font-size: 1rem!important;font-weight: 400!important;text-transform: uppercase;">
                      Đăng kí&nbsp;
                      <div class="ripple-effect" hidden></div>
                    </button>
                  </CCol>
                </CRow>
                <div
                  style="text-align: center;border-top: 1px solid rgba(170,170,170,0.34);margin-top: 25px; display: block;position: relative;">
                    <span
                      style="margin: 0 auto;top: -11px;  background: #fff;padding: 0 5px;position: relative;">
                      Hoặc đăng kí với
                    </span>
                </div>
                <div class="group-button-special">
                  <div class="btn btn-special-google" @click="signInGooogle">
                    <svg enable-background="new 0 0 512 512" height="17" width="17"
                         viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                      <g>
                        <path
                          d="m120 256c0-25.367 6.989-49.13 19.131-69.477v-86.308h-86.308c-34.255 44.488-52.823 98.707-52.823 155.785s18.568 111.297 52.823 155.785h86.308v-86.308c-12.142-20.347-19.131-44.11-19.131-69.477z"
                          fill="#fbbd00"/>
                        <path
                          d="m256 392-60 60 60 60c57.079 0 111.297-18.568 155.785-52.823v-86.216h-86.216c-20.525 12.186-44.388 19.039-69.569 19.039z"
                          fill="#0f9d58"/>
                        <path
                          d="m139.131 325.477-86.308 86.308c6.782 8.808 14.167 17.243 22.158 25.235 48.352 48.351 112.639 74.98 181.019 74.98v-120c-49.624 0-93.117-26.72-116.869-66.523z"
                          fill="#31aa52"/>
                        <path
                          d="m512 256c0-15.575-1.41-31.179-4.192-46.377l-2.251-12.299h-249.557v120h121.452c-11.794 23.461-29.928 42.602-51.884 55.638l86.216 86.216c8.808-6.782 17.243-14.167 25.235-22.158 48.352-48.353 74.981-112.64 74.981-181.02z"
                          fill="#3c79e6"/>
                        <path
                          d="m352.167 159.833 10.606 10.606 84.853-84.852-10.606-10.606c-48.352-48.352-112.639-74.981-181.02-74.981l-60 60 60 60c36.326 0 70.479 14.146 96.167 39.833z"
                          fill="#cf2d48"/>
                        <path
                          d="m256 120v-120c-68.38 0-132.667 26.629-181.02 74.98-7.991 7.991-15.376 16.426-22.158 25.235l86.308 86.308c23.753-39.803 67.246-66.523 116.87-66.523z"
                          fill="#eb4132"/>
                      </g>
                    </svg>
                    Google
                  </div>
                  <div class="btn btn-special-facebook" @click="signInFB">
                    <svg height="18" width="18" version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                         viewBox="0 0 112.196 112.196" style="enable-background:new 0 0 112.196 112.196;"
                         xml:space="preserve">
                        <g>
                          <circle style="fill:#3B5998;" cx="56.098" cy="56.098" r="56.098"/>
                          <path style="fill:#FFFFFF;" d="M70.201,58.294h-10.01v36.672H45.025V58.294h-7.213V45.406h7.213v-8.34
                            c0-5.964,2.833-15.303,15.301-15.303L71.56,21.81v12.51h-8.151c-1.337,0-3.217,0.668-3.217,3.513v7.585h11.334L70.201,58.294z"/>
                        </g>
                      </svg>
                    Facebook
                  </div>
                </div>
                <div style="text-align: center; margin-top: 15px;">
                  <span>Bạn đã có tài khoản?</span><span
                  style="cursor: pointer;font-weight: bold;" @click="loginSubmit"> Quay lại trang đăng nhập</span>
                </div>
                <div style="display: flex;justify-content: center;margin-bottom: 15px;">
                </div>
                <!--                </CForm>-->
              </CCardBody>
            </CCard>
          </div>
        </CCol>
      </CRow>
    </div>
    <BaseLoading :loading="loading.value"></BaseLoading>
  </div>
</template>
<script>
  import $ from "jquery";

  import Vue from "vue";
  import GAuth from "vue-google-oauth2";
  import BaseLoading from "../base/BaseFormLoading";
  import BaseInput from "../base/BaseInput";

  const gauthOption = {
    clientId: '537421769342-979ifnfs9c0781e17uau9lk1iuton5ps.apps.googleusercontent.com',
    scope: 'profile email',
    prompt: 'select_account'
  }

  Vue.use(GAuth, gauthOption);
  import {authLogin} from "@/security/index";

  export default {
    name: 'register',
    components: {GAuth, BaseInput, BaseLoading},
    notifications: {
      showSuccessMsg: {
        type: 'success',
        title: 'Success',
      },
      showErrorMsg: {
        type: 'error',
        title: 'Errors',
      },
      showWarningMsg: {
        type: "warn",
        title: "warn"
      }
    },
    data: function () {
      let that = this;
      return {
        loading: {value: false},
        fullNameInput: {
          options: {
            placeholder: "Tên của bạn",
            type: "text"
          },
          data: {
            name: "fullName",
            model: "",
            validator: {
              isValid: true,
              errorMessage: "",
              valid: function () {
                let value = that.fullNameInput.data.model;
                if (value === '') {
                  this.isValid = false;
                  this.errorMessage = 'Tên của bạn không để trống';
                } else {
                  this.isValid = true;
                  this.errorMessage = ''
                }
                return this.isValid;
              }
            }
          }
        },
        emailInput: {
          options: {
            placeholder: "Email",
            type: "text"
          },
          data: {
            name: "email",
            model: "",
            validator: {
              isValid: true,
              errorMessage: "",
              valid: function () {
                let value = that.emailInput.data.model;
                let email_regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                if (value === "") {
                  this.isValid = false;
                  this.errorMessage = "Email không được để trống";
                } else if (email_regex.test(value) == false) {
                  this.isValid = false;
                  this.errorMessage = "Email không đúng định dạng";
                } else if (email_regex.test(value) == true) {
                  this.isValid = true;
                }
                return this.isValid;
              }
            }
          }
        },
        userNameInput: {
          options: {
            placeholder: "Tài khoản",
            type: "text"
          },
          data: {
            name: "userName",
            model: "",
            validator: {
              isValid: true,
              errorMessage: "",
              valid: function () {
                let value = that.userNameInput.data.model;
                let username_regex = /^([a-zA-Z0-9 !%&@#$^*?_~]){6,}$/;
                if (value === "") {
                  this.isValid = false;
                  this.errorMessage = "Tên đăng nhập không được để trống";
                } else if (username_regex.test(value) == false) {
                  this.isValid = false;
                  this.errorMessage =
                    "Tên đăng nhập ít nhất 6 kí tự và là chữ thường";
                } else if (username_regex.test(value) == true) {
                  this.isValid = true;
                  this.errorMessage = "";
                }
                return this.isValid;
              }
            }
          }
        },
        passWordInput: {
          options: {
            placeholder: "Mật khẩu",
            type: "password"
          },
          data: {
            name: "password",
            model: "",
            validator: {
              isValid: true,
              errorMessage: "",
              valid: function () {
                let value = that.passWordInput.data.model;
                let password_regex = /^(?=(?:[^A-Z]*[A-Z]){1,})(?=(?:[^a-z]*[a-z]){1,})(?=(?:[^0-9]*[0-9]){1,}).{8,}$/;
                if (value === "") {
                  this.isValid = false;
                  this.errorMessage = "Mật khẩu không được để trống";
                } else if (password_regex.test(value) == false) {
                  this.isValid = false;
                  this.errorMessage =
                    "Mật khẩu ít nhất 8 kí tự gồm chữ hoa, chữ thường, số";
                } else if (password_regex.test(value) == true) {
                  this.isValid = true;
                  this.errorMessage = "";
                }
                return this.isValid;
              }
            }
          }
        },
      }
    },
    mounted: function () {
      let that = this;
      setTimeout(function () {
        that.setUpRippleButton();
      }, 1000);
    },
    methods: {
      /*Start Google*/
      signInGooogle: function () {
        let that = this;
        this.$gAuth.signIn()
          .then(GoogleUser => {
            let accessToken = GoogleUser.getAuthResponse().access_token;
            if (accessToken != null) {
              that.$helper.loadDataSource({
                loading: that.loading,
                url: "/user/loginAndRegByGoogle",
                isJsonContentType: false,
                dataSubmit: function () {
                  return {access_token: accessToken, type: 2};
                },
                successCallback: function (response) {
                  let dataResponse = response.data;
                  if (dataResponse.returnCode !== 1 && dataResponse.returnCode !== 2) {
                    that.showErrorMsg({
                      message: that.$helper.getStringError(response.data.data)
                    });
                  } else if (dataResponse.returnCode === 2) {
                    that.$router.push({
                      name: "complete-reg",
                      params: {email: dataResponse.data.email, name: dataResponse.data.name}
                    });
                  } else {
                    that.showSuccessMsg({
                      message: 'Email này đã được đăng ký.'
                    });
                    that.$router.push('/');
                  }
                },
                errorCallback: function (error) {
                  that.$helper.handleError(that.$router, error);
                }
              });
            }
          })
          .catch(error => {
            console.log(error);
          });
      },
      /*End Google*/
      /*Start FB*/
      initFacebook: function () {
        window.fbAsyncInit = function () {
          window.FB.init({
            appId: "757304778134032",
            cookie: true,
            version: "v6.0"
          });
          window.FB.AppEvents.logPageView();
        };
      },
      loadFacebookSDK: function (d, s, id) {
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {
          return;
        }
        js = d.createElement(s);
        js.id = id;
        js.src = "https://connect.facebook.net/en_US/sdk.js";
        fjs.parentNode.insertBefore(js, fjs);
      },
      signInFB() {
        let that = this;
        window.FB.login(function (response) {
          if (response.authResponse) {
            that.$helper.loadDataSource({
              loading: that.loading,
              url: "/user/loginAndRegByFacebook",
              isJsonContentType: false,
              dataSubmit: function () {
                return {access_token: response.authResponse.accessToken, type: 2};
              },
              successCallback: function (response) {
                let dataResponse = response.data;
                if (dataResponse.returnCode !== 1 && dataResponse.returnCode !== 2) {
                  that.showErrorMsg({
                    message: that.$helper.getStringError(response.data.data)
                  });
                } else if (dataResponse.returnCode === 2) {
                  that.$router.push({
                    name: "complete-reg",
                    params: {email: "", name: dataResponse.data.name, idFb: dataResponse.data.id}
                  });
                } else {
                  that.showSuccessMsg({message: 'Tài khoản Facebook này được đăng ký.'})
                  that.$router.push('/');
                }
              },
              errorCallback: function (error) {
                that.$helper.handleError(that.$router, error);
              }
            });
          }
        });
        return false;
      },
      /*End Facebook*/

      submit: function () {
        let that = this;
        that.$helper.loadDataSource({
          loading: that.loading,
          url: "/user/registerAccountCustomer",
          dataRef: function () {
            return that.$data;
          },
          successCallback: function (response) {
            let dataResponse = response.data;
            if (dataResponse.returnCode !== 1) {
              that.showErrorMsg({
                message: that.$helper.getStringError(response.data.data)
              });
            } else {
              authLogin(
                dataResponse.data.access_token,
                dataResponse.data.Authorities,
                dataResponse.data.username
              );
            }
          },
          errorCallback: function (error) {
            that.$helper.handleError(that.$router, error);
          }
        });
      },

      setUpRippleButton: function () {
        $('.ripple').on('click', function (event) {
          event.preventDefault();
          var $div = $('<div/>'),
            btnOffset = $(this).offset(),
            xPos = event.pageX - btnOffset.left,
            yPos = event.pageY - btnOffset.top;
          $div.addClass('ripple-effect');
          var $ripple = $(".ripple-effect");
          $div.css({
            top: yPos - ($ripple.height() / 2),
            left: xPos - ($ripple.width() / 2),
          })
            .appendTo($(this));
          window.setTimeout(function () {
            $div.remove();
          }, 1500);
        });
      },
      loginSubmit: function () {
        this.$router.push('/').catch(e => {
        });
      }
    },
  }
</script>

<style>
  #form-register .input-wrapper > div > input {
    height: 42px !important;
  }
</style>
<style scoped>
  .group-button-special {
    margin-top: 10px;
    text-align: center;
    display: flex;
    justify-content: center;
  }

  .btn-special-google, .btn-special-facebook {
    border: 1px solid #aaa;
    margin-right: 5px;
    width: 40%;
    font-size: 17px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .btn-special-google:hover {
    border-color: #ff8500;
    color: #ff8500;
  }

  .btn-special-facebook:hover {
    border-color: #0064ff;
    color: #1d70ff;
  }

  .btn-special-google svg,
  .btn-special-facebook svg {
    margin-right: 5px !important;
  }

  #register {
    margin-top: 15px;
  }

  #register:hover {
    background: rgba(13, 175, 223, 1) !important;
  }


  fieldset {
    border: 1px solid #ccc;
    padding: 15px;
    max-width: 345px;
    background-color: #fff;
    border-radius: 5px;
  }

  section {
    padding: 0 15px;
  }

  @media (max-width: 350px) {
    .btn-special-google[data-v-07b13bd8], .btn-special-facebook[data-v-07b13bd8] {
      width: unset !important;
    }

    .container {
      padding: 0px !important;
    }

    #content-left {
      width: 0;
      height: 0;
    }
  }

  @media (min-width: 350px) and (max-width: 575px) {
    .container {
      padding: 0px !important;
    }

    #content-left {
      width: 0;
      height: 0;
    }
  }

  @media (min-width: 576px) and (max-width: 767px) {
    .btn-special-google, .btn-special-facebook {
      font-size: 13px;
    }

    .container {
      padding: 0px !important;
    }

    #content-right {
      padding-left: 0px;
      padding-right: 0;
    }

    .card-body {
      padding: 1.25rem 15px !important;;
    }
  }

  @media (min-width: 768px) and (max-width: 1100px) {
    .btn-special-google, .btn-special-facebook {
      font-size: 13px;
    }
  }
</style>

